import { ToastContentProps } from 'react-toastify/dist/types'

export type TCustomToastContentProps<T = unknown> = ToastContentProps<T>

export enum ENotificationContainerIds {
  SYSTEM = 'systemNotification',
  EVENT = 'eventNotification'
}
